import React, { useEffect, useState } from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';

const SubscriptionSuccess = ({ onContinue }) => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onContinue();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onContinue]);

  return (
    <div className="container">
      <div className="card subscription-success">
        <div className="success-icon">
          <CheckCircle size={64} color="#10b981" />
        </div>
        
        <h1>🎉 Welcome to OnlyBeanz Premium!</h1>
        
        <div className="premium-badge">
          👑
          <span>Premium Member</span>
        </div>
        
        <div className="success-message">
          <h2>Your subscription is now active!</h2>
          <p>Thank you for upgrading to Premium. You now have access to all premium features:</p>
          
          <div className="premium-features">
            <div className="feature-item">
              <CheckCircle size={20} color="#10b981" />
              <span>✨ Unlimited bean uploads</span>
            </div>
            <div className="feature-item">
              <CheckCircle size={20} color="#10b981" />
              <span>📊 Advanced analytics</span>
            </div>
            <div className="feature-item">
              <CheckCircle size={20} color="#10b981" />
              <span>🚫 Ad-free experience</span>
            </div>
            <div className="feature-item">
              <CheckCircle size={20} color="#10b981" />
              <span>👑 Premium badge</span>
            </div>
            <div className="feature-item">
              <CheckCircle size="20" color="#10b981" />
              <span>💖 Extra super likes</span>
            </div>
            <div className="feature-item">
              <CheckCircle size={20} color="#10b981" />
              <span>🛠️ Priority support</span>
            </div>
          </div>
        </div>
        
        <div className="success-actions">
          <button 
            onClick={onContinue}
            className="continue-button"
          >
            <span>Start Using Premium Features</span>
            <ArrowRight size={20} />
          </button>
          
          <p className="auto-redirect">
            Automatically continuing in {countdown} seconds...
          </p>
        </div>
        
        <div className="support-info">
          <p>
            Questions? Contact us at <strong>support@onlybeanz.app</strong>
          </p>
          <p>
            You can manage your subscription anytime from your profile.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;